import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { api } from '@/lib/api';

export default function AdminEvents() {
    const [events, setEvents] = useState([]);
    useEffect(() => { api.get('/admin/events').then(({ data }) => setEvents(data)); }, []);

    return (
        <AdminLayout>
            <div className="p-10" data-testid="admin-events-page">
                <div className="overline">Events</div>
                <h1 className="font-serif text-4xl text-navy mt-2 mb-8">All Events</h1>
                <div className="grid md:grid-cols-2 gap-4">
                    {events.map((e) => (
                        <div key={e.id} className="bg-white border border-border-subtle p-6 flex gap-4">
                            <img src={e.image_url} alt="" className="w-32 h-32 object-cover shrink-0" />
                            <div className="flex-1">
                                <div className="overline text-gold mb-1">{e.event_type.replace('_', ' ')}</div>
                                <div className="font-serif text-xl text-navy">{e.title}</div>
                                <div className="text-xs text-text-tertiary mt-1">{e.mall_name} • {e.venue}</div>
                                <div className="text-xs text-text-tertiary">{new Date(e.start_datetime).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</div>
                                <div className="mt-3 flex gap-4 text-xs">
                                    <span>Registered: <strong>{e.registered_count}/{e.capacity}</strong></span>
                                    <span>Points: <strong className="text-gold">+{e.points_for_attending}</strong></span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </AdminLayout>
    );
}
